/* ============================================================
   contact-conditional.js — Topic-scoped conditional fields.

   Originally Phase 9b.4 SD-4 D13 Option (ii): one conditional block,
   shown for topics ∈ {fitment, sourcing, order}.

   Refactored 2026-05-08 (Jodi feedback): split into two topic-scoped
   blocks. Different topics need different helper fields.
     - fitment / sourcing → "fitment-sourcing" block (vehicle + part #)
     - order / return     → "order-return" block (order # + photos)
     - wholesale / other  → no block
     - empty (no topic)   → no block

   Block visibility is controlled by the data-contact-conditional attr
   on each block, which holds the block's identifier. We map topic →
   block identifier and show only the matching block. The form field
   `[data-contact-required-when]` is toggled to/from required based on
   which block is active — `required` on a hidden input would block
   form submission for unrelated topics.

   Loaded only at /pages/contact via main-page-contact.liquid asset_url tag.
   ============================================================ */
(function () {
  'use strict';

  // Topic → block identifier mapping. Keep in sync with
  // sections/main-page-contact.liquid <select name="contact[topic]"> values
  // AND the data-contact-conditional attribute values on the conditional
  // <div> blocks.
  var TOPIC_TO_BLOCK = {
    fitment: 'fitment-sourcing',
    sourcing: 'fitment-sourcing',
    order: 'order-return',
  };

  function init() {
    var topicSelect = document.querySelector('.contact-form select[name="contact[topic]"]');
    var blocks = document.querySelectorAll('.contact-form [data-contact-conditional]');
    if (!topicSelect || blocks.length === 0) return;

    function update() {
      var activeBlockId = TOPIC_TO_BLOCK[topicSelect.value] || null;
      blocks.forEach(function (block) {
        var blockId = block.dataset.contactConditional;
        var shouldShow = blockId === activeBlockId;
        block.hidden = !shouldShow;
        // Toggle required on inputs that are required when their block is active.
        var conditionallyRequired = block.querySelectorAll('[data-contact-required-when]');
        conditionallyRequired.forEach(function (input) {
          var requiredFor = input.dataset.contactRequiredWhen;
          if (shouldShow && requiredFor === blockId) {
            input.setAttribute('required', '');
          } else {
            input.removeAttribute('required');
          }
        });
      });
    }

    topicSelect.addEventListener('change', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
